import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { VisitantesRoutingModule } from './visitantes-routing.module';

import { ComponentesCompartidosModule } from '../componentes-compartidos/componentes-compartidos.module';

import { PaginaVisitantesComponent } from './pagina-visitantes/pagina-visitantes.component';

import { UsuariosService } from 'src/app/servicios/usuarios.service';
import { DetalleVisitanteComponent } from './detalle-visitante/detalle-visitante.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';


@NgModule({ declarations: [
        PaginaVisitantesComponent,
        DetalleVisitanteComponent,
    ],
    exports: [
        PaginaVisitantesComponent
    ], imports: [MatIconModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        CommonModule,
        ReactiveFormsModule,
        VisitantesRoutingModule,
        ComponentesCompartidosModule,
        MatCheckboxModule], providers: [
        UsuariosService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class VisitantesModule { }
